module.exports = __webpack_public_path__ + "static/media/sf-trial-correct.3a44bcb9.mp3";